module.exports = __webpack_public_path__ + "img/member-app-logo.e18aceee.jpg";